import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=43b71518&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b71518"]])

export default __exports__